import { useEffect, useState } from 'react';
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from '@/shared/ui/sheet';
import { Skeleton } from '@/shared/ui/skeleton';
import type { SegmentationCriteria } from '@/shared/types/segmentation';
import { fetchSegmentationSample, type SegmentationSampleLead } from '../api/use-segmentations';

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  idPassbook: string;
  criteria: SegmentationCriteria;
}

/** "Amostra de Leads" -- mesmo conceito do drawer da RD Station anexado no
 * pedido original, AO VIVO (nunca é isso que o disparo usa). */
export function SegmentationSampleDrawer({ open, onOpenChange, idPassbook, criteria }: Props) {
  const [leads, setLeads] = useState<SegmentationSampleLead[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) return;
    setLoading(true);
    fetchSegmentationSample(idPassbook, criteria, 10)
      .then(setLeads)
      .catch(() => setLeads([]))
      .finally(() => setLoading(false));
  }, [open, idPassbook, criteria]);

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent>
        <SheetHeader>
          <SheetTitle>Amostra de Leads</SheetTitle>
          <SheetDescription>Até 10 leads que batem com os critérios definidos ao lado.</SheetDescription>
        </SheetHeader>

        {loading ? (
          <div className="flex flex-col gap-3">
            {Array.from({ length: 5 }).map((_, i) => (
              <Skeleton key={i} className="h-12 w-full" />
            ))}
          </div>
        ) : leads.length === 0 ? (
          <div className="flex flex-1 flex-col items-center justify-center gap-2 py-12 text-center">
            <p className="text-sm font-medium">Comece a criar sua segmentação</p>
            <p className="text-sm text-muted-foreground">
              Use as condições ao lado para definir filtros com base nas ações e propriedades dos Leads da sua base.
            </p>
          </div>
        ) : (
          <ul className="flex flex-col divide-y divide-border/60">
            {leads.map((lead) => (
              <li key={lead._id} className="flex flex-col gap-0.5 py-3">
                <p className="text-sm font-medium">{lead.profile?.name || 'Sem nome'}</p>
                <p className="text-xs text-muted-foreground">
                  {[lead.email, lead.phone, lead.storeName].filter(Boolean).join(' · ') || '—'}
                </p>
              </li>
            ))}
          </ul>
        )}
      </SheetContent>
    </Sheet>
  );
}
